import { Injectable } from '@angular/core';
import { AuthorizeGuard } from '@platform/auth/authorize.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { UserListGuard } from './user-list.guard';

@Injectable({
  providedIn: 'root',
})
export class UserListCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthorizeGuard, userListGuard: UserListGuard) {
    super([authGuard, userListGuard]);
  }
}
